var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 17.284L9.375 13.7423L10.5417 12.5757L12.9167 14.9507L17.625 10.2423L18.7917 11.409L12.9167 17.284ZM17.5 9.01318H15.8333V4.84652H14.1667V7.34652H5.83333V4.84652H4.16667V16.5132H9.16667V18.1798H4.16667C3.70833 18.1798 3.31597 18.0167 2.98958 17.6903C2.66319 17.3639 2.5 16.9715 2.5 16.5132V4.84652C2.5 4.38818 2.66319 3.99582 2.98958 3.66943C3.31597 3.34304 3.70833 3.17985 4.16667 3.17985H7.64583C7.79861 2.69374 8.09722 2.29443 8.54167 1.98193C8.98611 1.66943 9.47222 1.51318 10 1.51318C10.5556 1.51318 11.0521 1.66943 11.4896 1.98193C11.9271 2.29443 12.2222 2.69374 12.375 3.17985H15.8333C16.2917 3.17985 16.684 3.34304 17.0104 3.66943C17.3368 3.99582 17.5 4.38818 17.5 4.84652V9.01318ZM10 4.84652C10.2361 4.84652 10.434 4.76666 10.5938 4.60693C10.7535 4.44721 10.8333 4.24929 10.8333 4.01318C10.8333 3.77707 10.7535 3.57916 10.5938 3.41943C10.434 3.25971 10.2361 3.17985 10 3.17985C9.76389 3.17985 9.56597 3.25971 9.40625 3.41943C9.24653 3.57916 9.16667 3.77707 9.16667 4.01318C9.16667 4.24929 9.24653 4.44721 9.40625 4.60693C9.56597 4.76666 9.76389 4.84652 10 4.84652Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.de92867641a20c8d4e94d09b31f3452c.svg";
export { ForwardRef as ReactComponent };